import {
  MemberInformation_default
} from "./chunk-XNCTVCOY.js";
import {
  withMemberViewModel
} from "./chunk-HZ3OFIQH.js";
import {
  EditHeader
} from "./chunk-ZVOJGXKE.js";
import {
  A as A2
} from "./chunk-NOXTDZLK.js";
import {
  A
} from "./chunk-IMO44CPR.js";
import {
  Spinner
} from "./chunk-POLRV4GK.js";
import {
  A as A3
} from "./chunk-NNGRNXS6.js";
import {
  PAGE_STATUS
} from "./chunk-OSVSI4BW.js";
import {
  __publicField
} from "./chunk-JCO6WRHX.js";

// src/pages/Members/MemberEdit/index.tsx
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import { ORGANISATION_MEMBER_FIELD } from "aesirx-lib";
import SimpleReactValidator from "simple-react-validator";
import _ from "lodash";
var EditMember = observer(
  class EditMember2 extends Component {
    constructor(props) {
      super(props);
      __publicField(this, "memberDetailViewModel", null);
      __publicField(this, "validator");
      __publicField(this, "formPropsData", { [ORGANISATION_MEMBER_FIELD.CUSTOM_FIELDS]: {} });
      __publicField(this, "isEdit", false);
      __publicField(this, "debouncedChangeHandler", _.debounce((value) => {
        this.memberDetailViewModel.handleAliasChange(value);
      }, 300));
      this.state = {};
      this.validator = new SimpleReactValidator({ autoForceUpdate: this });
      this.memberDetailViewModel = props.model?.memberDetailViewModel ? props.model?.memberDetailViewModel : null;
      this.memberDetailViewModel.setForm(this);
      this.isEdit = props.match.params?.id ? true : false;
    }
    async componentDidMount() {
      const { match } = this.props;
      if (this.isEdit) {
        this.formPropsData[ORGANISATION_MEMBER_FIELD.ID] = match.params?.id;
        await this.memberDetailViewModel.initializeData();
      }
      await this.memberDetailViewModel.getRoleList();
    }
    handleValidateForm() {
      if (this.validator.fields["Member Name"] === true) {
        this.setState((prevState) => {
          return {
            ...prevState,
            requiredField: Math.random()
          };
        });
      }
      this.validator.showMessages();
    }
    render() {
      const { t, history } = this.props;
      console.log("rerender Member");
      return /* @__PURE__ */ React.createElement("div", { className: "py-4 px-3 h-100 d-flex flex-column" }, this.memberDetailViewModel.formStatus === PAGE_STATUS.LOADING && /* @__PURE__ */ React.createElement(Spinner, { className: "spinner-overlay" }), /* @__PURE__ */ React.createElement("div", { className: "d-flex align-items-center justify-content-between mb-24 flex-wrap" }, /* @__PURE__ */ React.createElement(
        EditHeader,
        {
          props: this.props,
          title: t("txt_member"),
          isEdit: this.isEdit,
          redirectUrl: "/members"
        }
      ), /* @__PURE__ */ React.createElement("div", { className: "position-relative" }, /* @__PURE__ */ React.createElement(
        A3,
        {
          buttons: [
            {
              title: t("txt_cancel"),
              handle: async () => {
                history.push(`/members`);
              },
              icon: "/assets/images/cancel.svg"
            },
            {
              title: t("txt_save_close"),
              handle: async () => {
                if (this.validator.allValid()) {
                  const result = this.isEdit ? await this.memberDetailViewModel.update() : await this.memberDetailViewModel.create();
                  if (!result?.error) {
                    history.push(`/members`);
                  }
                } else {
                  this.handleValidateForm();
                }
              }
            },
            {
              title: t("txt_save"),
              validator: this.validator,
              handle: async () => {
                if (this.validator.allValid()) {
                  if (this.isEdit) {
                    await this.memberDetailViewModel.update();
                    await this.memberDetailViewModel.initializeData();
                    this.forceUpdate();
                  } else {
                    const result = await this.memberDetailViewModel.create();
                    if (!result?.error) {
                      history.push(`/members/edit/${result?.response}`);
                    }
                  }
                } else {
                  this.handleValidateForm();
                }
              },
              icon: "/assets/images/save.svg",
              variant: "success"
            }
          ]
        }
      ))), /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Row, { className: "gx-24 mb-24" }, /* @__PURE__ */ React.createElement(Col, { lg: 9 }, /* @__PURE__ */ React.createElement(Form.Group, { className: `mb-24` }, /* @__PURE__ */ React.createElement(
        A,
        {
          field: {
            getValueSelected: this.memberDetailViewModel.memberDetailViewModel.formPropsData[ORGANISATION_MEMBER_FIELD.MEMBER_NAME],
            classNameInput: "py-10 fs-4",
            placeholder: t("txt_add_member_name"),
            handleChange: (event) => {
              this.memberDetailViewModel.handleFormPropsData(
                ORGANISATION_MEMBER_FIELD.MEMBER_NAME,
                event.target.value
              );
            },
            required: true,
            validation: "required",
            blurred: () => {
              this.validator.showMessageFor("Member Name");
            }
          }
        }
      ), this.validator.message(
        "Member Name",
        this.memberDetailViewModel.memberDetailViewModel.formPropsData[ORGANISATION_MEMBER_FIELD.MEMBER_NAME],
        "required",
        {
          className: "text-danger mt-8px"
        }
      )), /* @__PURE__ */ React.createElement(
        MemberInformation_default,
        {
          validator: this.validator,
          messagesShown: this.validator.messagesShown,
          isEdit: this.isEdit,
          formPropsData: this.memberDetailViewModel.memberDetailViewModel.formPropsData,
          ...this.props
        }
      )), /* @__PURE__ */ React.createElement(Col, { lg: 3 }, /* @__PURE__ */ React.createElement(
        A2,
        {
          detailViewModal: this.memberDetailViewModel,
          formPropsData: this.memberDetailViewModel.memberDetailViewModel.formPropsData,
          isEdit: this.isEdit,
          isFeatured: false,
          isPublishedSimple: true
        }
      )))));
    }
  }
);
var MemberEdit_default = withTranslation()(withRouter(withMemberViewModel(EditMember)));

export {
  MemberEdit_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
